import React from 'react';
import { Gift } from 'lucide-react';
interface BonusCardProps {
  image: string;
  title: string;
  description: string;
  number: number;
}
export function BonusCard({
  image,
  title,
  description,
  number
}: BonusCardProps) {
  const scrollToPurchase = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div onClick={scrollToPurchase} className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-xl transition-all duration-300 cursor-pointer group border border-pastel-200 flex flex-col h-full" data-id="element-171">
      <div className="relative h-80 overflow-hidden bg-gray-50 flex items-center justify-center p-6" data-id="element-172">
        <img src={image} alt={title} className="w-full h-full object-contain group-hover:scale-105 transition-transform duration-500" data-id="element-173" />
        <div className="absolute top-0 left-0 bg-amber-500 text-white text-xs font-bold px-3 py-1 rounded-br-lg uppercase tracking-wider" data-id="element-174">
          Regalo #{number}
        </div>
      </div>
      <div className="p-6 flex flex-col flex-grow" data-id="element-175">
        <div className="flex items-start gap-2 mb-3" data-id="element-176">
          <Gift className="w-5 h-5 text-pastel-700 flex-shrink-0 mt-1" data-id="element-177" />
          <h3 className="text-lg font-bold text-gray-900 leading-tight group-hover:text-pastel-700 transition-colors" data-id="element-178">
            {title}
          </h3>
        </div>
        <p className="text-gray-600 text-sm leading-relaxed flex-grow" data-id="element-179">
          {description}
        </p>
        <div className="mt-4 pt-4 border-t border-gray-100 text-center" data-id="element-180">
          <span className="text-sm font-semibold text-amber-600 group-hover:underline" data-id="element-181">
            ¡GRATIS HOY!
          </span>
        </div>
      </div>
    </div>;
}